<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { computed } from 'vue';

  import { LEAFLINK_PLUS_ID, SPLIT_NAMES } from '@/constants';
  import { useUserStore } from '@/piniaStores/user/user.store';
  import { i18n } from '@/plugins';
  import { useProductsQuery } from '@/queries/feature-enrollment/feature-enrollment.query';

  import Container from './Container.vue';
  import StartFreeTrialButton from './StartFreeTrialButton.vue';

  const { getIsSplitEnabled } = storeToRefs(useUserStore());

  const isNueIntegrationEnabled = computed(() => {
    return getIsSplitEnabled.value(SPLIT_NAMES.ENROLLMENT_NUE_INTEGRATION);
  });

  const productsQuery = useProductsQuery({
    enabled: isNueIntegrationEnabled.value,
  });

  const isFreeTrial = computed(() => {
    const llPlusProduct = productsQuery.data.value?.find((product) => product.nueId === LEAFLINK_PLUS_ID);
    return llPlusProduct?.freeTrialUnit !== undefined && llPlusProduct?.freeTrialUnit !== '0';
  });
</script>

<template>
  <div class="tw-bg-purple">
    <Container class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-py-16 tw-overflow-hidden tw-text-center">
      <p class="tw-text-xl tw-text-white tw-px-8 lg:tw-px-12">
        {{ i18n.t('inventoryInsights.upgradeLeafLinkPlusPage.footer.description') }}
      </p>

      <StartFreeTrialButton class="tw-w-[300px] tw-mt-4" :location="'Footer'">
        {{ isFreeTrial ? i18n.t('inventoryInsights.startFreeTrial') : i18n.t('common.activate') }}
      </StartFreeTrialButton>
    </Container>
  </div>
</template>
